import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

export const NoData = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <h1>Нет данных</h1>
    </div>
  );
};
